<template>
  <div class="app-wrapper">
    <headerComponents />

    <main class="main">
      <router-view/>
    </main>
    
    <footerComponents :isSpecialFooter="isSpecialFooter"/>
  </div>
</template>




<script>
import headerComponents from '@/components/header.vue'
import footerComponents from '@/components/footer.vue'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    headerComponents,
    footerComponents,
  },
  methods: {
    
  },
  mounted() {
 
  },
  computed: {
    isSpecialFooter() {
      // Проверяем, является ли текущий роутер 'appsuport'
      if (this.$route.name === 'appsuport') {
        return true;
      }

      // Добавляем дополнительную проверку для нового роутера (например, 'newRoute')
      if (this.$route.name === 'submit') {
        return true;
      }

      // Возвращаем false для всех остальных случаев
      return false;
    }
  }

}
</script>
